
import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation, Thumbs, Autoplay, EffectFade } from 'swiper'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/thumbs'

export const About = () => {
   const ss = [...Array(5).keys()].map((i) => ++i)
    return (
        <>
            <div className='bg-ss1 min-h-screen'>
                <div className='container px-4'>
                    <div className='md:px-0 pt-[50%] md:pt-80 flex lg:flex-row flex-col space-x-0 space-y-8 md:space-y-0 lg:space-x-16 items-center '>
                        <Swiper
                            grabCursor={false}
                            navigation={false}
                            effect={'fade'}
                            pagination={true}
                            loop={true}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            // autoplay={false}
                            // onSlideChange={(swiper) => console.log(swiper.realIndex)}
                            modules={[Pagination, Navigation, Thumbs, Autoplay, EffectFade]}
                            className='mySwiper2 pb-12'
                        >
                            {ss.map((data) => (
                                <SwiperSlide>
                                    <img
                                        key={data.id}
                                        alt='screen shot of Rtype tactics game'
                                        src={`${process.env.PUBLIC_URL}/assets/ss${data}.webp`}
                                        className='mb-12 md:mb-20 shadow-lg '
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        <div className='basis-2/5 text-white text-base'>
                            <p className='pb-4'>
                                Outsmart and outgun your opponent in R-Type Tactics I • II Cosmos, the ultimate
                                turn-based sci-fi strategy collection!
                            </p>
                            <p className='pb-4'>
                                This two-game combination of the classic R-Type Tactics titles arrives on modern
                                consoles for the first time, equipped with an armada of unique units to deploy across
                                dozens of levels.
                            </p>
                            <p className='pb-4'>
                          Multiple campaigns allow you to take on the Bydo Empire or even play as them yourself.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
